/**
 * Browser media already responds to host suspension. React Native Web's
 * AppState compatibility emitter can dispatch a queued tab-change event after
 * its listener has been removed, throwing inside the emitter. Web therefore
 * avoids that compatibility layer; native engines use the shared hook.
 */
export function usePlayerAppState(_onInterrupted: () => void) {}
